module.exports = require('buffer-okam/');
